import { type FC } from 'react';

import { IconLoader2 } from '@tabler/icons-react';
import {
  ButtonField,
  Notification,
} from '@wk/components-react16';

import type { OnboardingConfigurationStatusPanelProps } from '@/features/onboarding/types/onboarding.types';

const OnboardingConfigurationStatusPanel: FC<
  OnboardingConfigurationStatusPanelProps
> = ({
  cancelLabel = 'Cancel',
  draftMessage,
  invalidItemCount,
  invalidItemLabel,
  isDeleting,
  isDraft,
  isSaving,
  onCancel,
  onSave,
  publishedMessage,
  saveLabel = 'Save Configuration',
  totalConfigurations,
}) => {
  if (isDraft) {
    return (
      <>
        <div className="subject-onboarding-draft-notifications flex flex-col">
          <Notification
            type="warning"
            heading=""
            autoCloseTimeout={0}
            hasCloseButton={false}
            hasAnimation={false}
          >
            <span slot="notificationContent">{draftMessage}</span>
          </Notification>
          {invalidItemCount > 0 ? (
            <Notification
              type="warning"
              heading=""
              autoCloseTimeout={0}
              hasCloseButton={false}
              hasAnimation={false}
            >
              <span slot="notificationContent">
                Configuration has{' '}
                <b>
                  {invalidItemCount} {invalidItemLabel}
                  {invalidItemCount > 1 ? 's' : ''}
                </b>{' '}
                that {invalidItemCount > 1 ? 'are' : 'is'} not configured.
                Please configure all {invalidItemLabel}
                {invalidItemCount > 1 ? 's' : ''} and save the configuration.
              </span>
            </Notification>
          ) : null}
        </div>
        <div className="flex flex-row items-center justify-end gap-2 max-sm:justify-start">
          {totalConfigurations > 1 ? (
            <ButtonField isDanger>
              <button onClick={onCancel} disabled={isDeleting || isSaving}>
                {cancelLabel}
                {isDeleting ? (
                  <IconLoader2 className="animate-spin" />
                ) : null}
              </button>
            </ButtonField>
          ) : null}
          <ButtonField>
            <button onClick={onSave} disabled={isSaving || isDeleting}>
              {saveLabel}
              {isSaving ? (
                <IconLoader2 className="animate-spin" />
              ) : null}
            </button>
          </ButtonField>
        </div>
      </>
    );
  }

  return (
    <Notification
      type="success"
      heading=""
      autoCloseTimeout={0}
      hasCloseButton={false}
      hasAnimation={false}
    >
      <span slot="notificationContent">{publishedMessage}</span>
    </Notification>
  );
};

export default OnboardingConfigurationStatusPanel;
